import { render } from "./UserProfileBasic.vue?vue&type=template&id=98efc024"
import script from "./UserProfileBasic.vue?vue&type=script&lang=ts"
export * from "./UserProfileBasic.vue?vue&type=script&lang=ts"
script.render = render

export default script